import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8e4f926c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8e4f926c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4f926c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarketsPriceTable: require('/app/nuxt/components/MarketsPricePage/MarketsPriceTable/index.vue').default})
